import { render, staticRenderFns } from "./BatchSizeWarning.vue?vue&type=template&id=17985837&scoped=true"
import script from "./BatchSizeWarning.vue?vue&type=script&lang=js"
export * from "./BatchSizeWarning.vue?vue&type=script&lang=js"
import style0 from "./BatchSizeWarning.vue?vue&type=style&index=0&id=17985837&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17985837",
  null
  
)

export default component.exports